import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferBeginCheckout} from "./offer/hit_gtm_offer_begin_checkout";
import {hitGTMPropertyBeginCheckout} from "./property/hit_gtm_property_begin_checkout";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceBeginCheckout = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string,
    formFillAction: "autofill" | "manual_fill" = "autofill"
) => {
    const propertyData = (data.property && data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyBeginCheckout(data, viewType, leadType, sourceSection, formFillAction);
    }

    return hitGTMOfferBeginCheckout(data, viewType, leadType, sourceSection, formFillAction);
};
import {ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {ILeadModalLeadType} from "../../../lead/types/ILeadModalLeadType";
import {ViewType} from "../../../view_type/ViewType";
import {hitGTMOfferBeginCheckout} from "./offer/hit_gtm_offer_begin_checkout";
import {hitGTMPropertyBeginCheckout} from "./property/hit_gtm_property_begin_checkout";
import {IGTMEcommerceAddProductData} from "./types/IGTMEcommerceAddProductData";

export const hitGTMEcommerceBeginCheckout = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection | string,
    formFillAction: "autofill" | "manual_fill" = "autofill"
) => {
    const propertyData = (data.property && data.property.detail) || undefined;

    if (propertyData) {
        return hitGTMPropertyBeginCheckout(data, viewType, leadType, sourceSection, formFillAction);
    }

    return hitGTMOfferBeginCheckout(data, viewType, leadType, sourceSection, formFillAction);
};
